module.exports = __webpack_public_path__ + "img/ico-reflection.259741c8.svg";